import React, { lazy } from 'react';
import Login from './pages/other/Login';
import Products from './pages/other/products';
import Orders from './pages/other/Orders';
import CreateReturn from './pages/other/CreateReturn';
import ReturnDetails from './pages/other/ReturnDetails';

// Home page (lazy-loaded) - rendered at "/" before ProtectedRoute redirects to /catalog-type
const HomeFashionTwo = lazy(() => import('./pages/home/HomeFashionTwo'));

// Shop pages (lazy-loaded)
const ShopGridStandard = lazy(() => import('./pages/shop/ShopGridStandard'));

// Product pages (lazy-loaded)
const Product = lazy(() => import('./pages/shop-product/Product'));

// Other pages (lazy-loaded)
const About = lazy(() => import('./pages/other/About'));
const Contact = lazy(() => import('./pages/other/Contact'));
const MyAccount = lazy(() => import('./pages/other/MyAccount'));
const Cart = lazy(() => import('./pages/other/Cart'));
const Wishlist = lazy(() => import('./pages/other/Wishlist'));
const Compare = lazy(() => import('./pages/other/Compare'));
const Checkout = lazy(() => import('./pages/other/Checkout'));
const NotFound = lazy(() => import('./pages/other/NotFound'));
const Client = lazy(() => import('./pages/other/Client'));
const OrderDetails = lazy(() => import('./pages/other/OrderDetails'));
const Category = lazy(() => import('./pages/other/Category'));
const CatalogTypeSelection = lazy(() => import('./pages/other/CatalogTypeSelection'));
const Downloads = lazy(() => import('./pages/other/Downloads'));


const routes = [
  // Home page
  {
    path: process.env.PUBLIC_URL + '/',
    element: <HomeFashionTwo />,
    protected: true,
  },

  // Shop pages
  {
    path: process.env.PUBLIC_URL + '/shop-grid-standard',
    element: <ShopGridStandard />,
    protected: true,
  },

  // Product pages
  {
    path: process.env.PUBLIC_URL + '/product/:id',
    element: <Product />,
    protected: true,
  },

  // Other pages
  {
    path: process.env.PUBLIC_URL + '/about',
    element: <About />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/contact',
    element: <Contact />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/my-account',
    element: <MyAccount />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/login',
    element: <Login />,
    protected: false,
    redirectIfAuthenticated: true,
  },
  {
    path: process.env.PUBLIC_URL + '/cart',
    element: <Cart />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/wishlist',
    element: <Wishlist />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/compare',
    element: <Compare />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/checkout',
    element: <Checkout />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/clients',
    element: <Client />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/catalog-type',
    element: <CatalogTypeSelection />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/products',
    element: <Products />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/orders/:orderId',
    element: <OrderDetails />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/orders',
    element: <Orders />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/orders/:orderId/createReturn',
    element: <CreateReturn />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/orders/:orderId/createSubstitution',
    element: <CreateReturn isSubstitution />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/orders/:orderId/:returnId',
    element: <ReturnDetails />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/categories',
    element: <Category />,
    protected: true,
  },
  {
    path: process.env.PUBLIC_URL + '/downloads',
    element: <Downloads />,
    protected: true,
  },

  // Fallback Route
  { path: '*', element: <NotFound />, protected: true },
];

export default routes;
